// Angular imports
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

// 3rd party imports
import { formatNumber } from 'devextreme/localization';

// Service imports
import { ServerErrorService } from '../../../../../_services/shared-services/server-error.service';
import { PrecisionService } from '../../../../../_services/shared-services/precision.service';
import { ARPaymentService } from '../../../_services/account-receivable/ar-payment.service';

// Constant imports
import { StringFormatConstants } from '../../../../../_constants/string-format-constants';

// Model imports
import { ARPaymentParameterDto } from '../../../_models/account-receivable/ar-payment/ar-payment-parameter-dto';
import { PaymentTransferHistoryResultDto } from '../../../_models/account-receivable/ar-payment/payment-transfer-history-result-dto';

@Component({
    selector: 'app-ar-payment-transfer-history',
    templateUrl: './ar-payment-transfer-history.component.html',
    styleUrls: ['./ar-payment-transfer-history.component.scss']
})
export class ARPaymentTransferHistoryComponent implements OnInit {
    @Input() visible = false;
    @Input() arPaymentParam: ARPaymentParameterDto;
    @Output() onTransferHistoryClose = new EventEmitter<boolean>();

    loadingVisible = false;
    dateTimeFormat = StringFormatConstants.dateTimeFormat;
    currencyFormat: string = StringFormatConstants.currencyFormat;

    popUpTitle: string;
    arPaymentTransferHistory: PaymentTransferHistoryResultDto[];

    constructor(
        private readonly errorService: ServerErrorService,
        private readonly precisionService: PrecisionService,
        private readonly arPaymentService: ARPaymentService
    ) {
        this.currencyFormat = this.precisionService.updatePrecisionPoint(this.currencyFormat);
    }

    ngOnInit() {
        if (!!this.arPaymentParam) {
            this.popUpTitle = 'AR Payment Transfer Logs ' + this.arPaymentParam.paymentId;
            this.populateTransferHistory();
        }
    }

    onShown(e: any): void {
        e.component.repaint();
    }

    onHidden(e: any): void {
        this.visible = false;
        this.onTransferHistoryClose.emit(false);
    }

    currencyFormatter(value: number): string {
        return formatNumber(value, this.currencyFormat);
    }

    private populateTransferHistory(): void {
        this.loadingVisible = true;
        this.arPaymentService.getARPaymentTransferHistory(this.arPaymentParam).subscribe(
            (result) => {
                this.arPaymentTransferHistory = result;
                this.loadingVisible = false;
            },
            (error) => {
                this.loadingVisible = false;
                this.errorService.displayError(error);
                this.onHidden(null);
            }
        );
    }
}
